import { all } from 'redux-saga/effects'
import { invoiceSaga } from './invoice/saga'

export function* socketSaga() {
  yield all([invoiceSaga()])
}
